import type { NodeViewerComponent } from '.'

export const TableRowNodeViewer: NodeViewerComponent = ({ children }) => {
  return <tr>{children}</tr>
}
